import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/main_website/Home';
import About from '../pages/main_website/About';
import Career from '../pages/main_website/Career';
import ContactUs from '../pages/main_website/ContactUs';
import Visit from '../pages/main_website/Visit';
import ProjectPage from '../pages/main_website/ProjectPage';
import ImageGallery from '../pages/main_website/ImageGallery';
import TermsConditions from '../pages/main_website/TermsCondition';
import NotFound from '../pages/main_website/NotFound';
import ProjectDetail from "../pages/main_website/ProjectDetail";

import AdminLogin from '../Admin/features/auth/Login';
import AdminDashboard from '../Admin/features/Dashboard/Dashboard';
import ProtectedRoute from '../Admin/utils/ProtectedRoute';
import AdminLayout from '../Admin/AdminLayout';
import { AuthProvider } from '../Admin/context/AuthContext';

const AppRoutes = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/visit" element={<Visit />} />
        <Route path="/image-gallery" element={<ImageGallery />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/project-details/:id" element={<ProjectDetail />} />
        {/* <Route path="/project-details/:id" element={<ProjectDetail />} /> */}
        <Route path="/project-details/:slug" element={<ProjectDetail />} />

        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
        </Route>

        <Route path="/:slug" element={<ProjectPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
};

export default AppRoutes;
